module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hPwuqQ/tc-custom/9780819571601.jpg?1726871191125",
      "alt": "This image is the cover for the book Always in Trouble"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Always in Trouble\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("You never heard such sounds in your life")])]), _c('p', [_vm._v(" In 1964, Bernard Stollman launched the independent record label ESP-Disk’ in New York City to document the free jazz movement there. A bare-bones enterprise, ESP was in the right place at the right time, producing albums by artists like Albert Ayler, Pharoah Sanders, and Sun Ra, as well as folk-rock bands like the Fugs and Pearls Before Swine. But the label quickly ran into difficulties and, due to the politically subversive nature of some productions and sloppy business practices, it folded in 1974. Always in Trouble tells the story of ESP-Disk’ through a multitude of voices—first Stollman’s, as he recounts the improbable life of the label, and then the voices of many of the artists involved. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jason Weiss\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("JASON WEISS is a freelance writer, editor, and translator. His books include Steve Lacy: Conversations and Back in No Time: The Brion Gysin Reader. Weiss lives in Brooklyn, New York.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wesleyan University Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0